import Controller from "./ratings.controller";
import template from "./ratings.html";

const ratings = {
  template,
  controller: Controller,
};

export default ratings;



// WEBPACK FOOTER //
// ./src/pages/ratings/ratings.component.js